import { BuildClass } from '../../../universal';
import { React, _ } from '../../lib';
import { Combobox } from './combobox';
import { DateBox } from './date';
import { Textbox } from './textbox';
const excludeFields = [
    'value',
    'onUpdate',
    'lbl',
    'tooltip',
    'onFocus',
    'onBlur',
    'className',
    'width',
];
export const TextboxFloating = (props) => {
    const refFloater = React.useRef(null);
    React.useEffect(() => {
        if (refFloater.current) {
            const hasValue = Boolean(props.value);
            refFloater.current.setHasValue(hasValue);
        }
    }, [props.value]);
    return (React.createElement(FloatingWrapper, { ref: refFloater, lbl: props.lbl, tooltip: props.tooltip, initHasValue: Boolean(props.value), className: props.className, width: props.width, alwaysFloatLabel: props.alwaysFloatLabel }, input => (React.createElement(Textbox, { className: "w-full", value: props.value, onUpdate: v => {
            props.onUpdate?.(v);
            input.onUpdate(Boolean(v));
        }, onFocus: ev => {
            props.onFocus?.(ev);
            input.onFocus();
        }, onBlur: ev => {
            props.onBlur?.(ev);
            input.onBlur();
        }, placeholder: "", ..._.omit(props, excludeFields) }))));
};
export const DateBoxFloating = (props) => {
    const refFloater = React.useRef(null);
    React.useEffect(() => {
        if (refFloater.current) {
            const hasValue = Boolean(props.value);
            refFloater.current.setHasValue(hasValue);
        }
    }, [props.value]);
    return (React.createElement(FloatingWrapper, { ref: refFloater, lbl: props.lbl, tooltip: props.tooltip, initHasValue: Boolean(props.value), className: props.className, width: props.width, alwaysFloatLabel: props.alwaysFloatLabel }, input => (React.createElement(DateBox, { className: "w-full", value: props.value, onUpdate: v => {
            props.onUpdate?.(v);
            input.onUpdate(Boolean(v));
        }, onFocus: ev => {
            props.onFocus?.(ev);
            input.onFocus();
        }, onBlur: ev => {
            props.onBlur?.(ev);
            input.onBlur();
        }, placeholder: "", ..._.omit(props, excludeFields) }))));
};
export const DropdownFloating = (props) => {
    const refFloater = React.useRef(null);
    React.useEffect(() => {
        if (refFloater.current) {
            const hasValue = Boolean(props.value);
            console.log({ hasValue, value: props.value });
            refFloater.current.setHasValue(hasValue);
        }
    }, [props.value]);
    return (React.createElement(FloatingWrapper, { ref: refFloater, lbl: props.lbl, tooltip: props.tooltip, initHasValue: Boolean(props.value), className: props.className, width: props.width, alwaysFloatLabel: props.alwaysFloatLabel }, input => (React.createElement(Combobox, { className: "w-full", value: props.value, onUpdate: v => {
            props.onUpdate?.(v);
            input.onUpdate(Boolean(v));
        }, onFocus: ev => {
            props.onFocus?.(ev);
            input.onFocus();
        }, onBlur: ev => {
            props.onBlur?.(ev);
            input.onBlur();
        }, placeholder: "", ..._.omit(props, excludeFields) }))));
};
export const StaticFloating = (props) => (React.createElement(FloatingWrapper, { lbl: props.lbl, tooltip: props.tooltip, initHasValue: true, className: props.className, width: props.width, alwaysFloatLabel: props.alwaysFloatLabel }, () => React.createElement("div", { className: "px-1" }, props.children)));
const FloatingWrapper = React.forwardRef((props, ref) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const [hasValue, setHasValue] = React.useState(props.initHasValue);
    React.useImperativeHandle(ref, () => ({
        setIsFocused,
        setHasValue,
    }));
    const isFloating = isFocused || hasValue || (props.alwaysFloatLabel ?? false);
    return (React.createElement("label", { className: BuildClass([
            'relative h-12 py-[2px]',
            'align-top inline-block',
            props.className ?? '',
        ]), style: { width: props.width ? `${props.width}px` : undefined } },
        React.createElement("div", { title: props.tooltip || props.lbl, className: BuildClass({
                'absolute px-1': true,
                'transform origin-top-left': true,
                'transition-all duration-200': true,
                'text-gray-500 translate-y-4 rounded-xs': true,
                'pointer-events-none select-none': true,
                'translate-x-[1px] translate-y-0 scale-75': isFloating,
                'bg-purple-600 text-white': isFocused,
                'leading-7': !isFloating,
            }) }, props.lbl),
        React.createElement("div", { className: "pt-4" }, props.children({
            onFocus: () => {
                setIsFocused(true);
            },
            onBlur: () => {
                setIsFocused(false);
            },
            onUpdate: hasValue => {
                setHasValue(hasValue);
            },
        }))));
});
//# sourceMappingURL=float-label.js.map